import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';

export const getPaymentsId = () => {
  return getQueryParams().paymentsId;
};
